import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, LL_H_C, TS_Radio } from '@nu-art/thunderstorm-frontend/index';
import { exists } from '@nu-art/ts-common';
import { DefaultEditor_InputTime } from '@app/styles/frontend/ui-manager/ui-components';
import './Renderer_EHROrderTime.scss';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/editable-item';
export class EHROrderTimeInput extends TS_EditableItemComponent {
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.editMode = nextProps.editMode;
        return state;
    }
    // ######################## Logic ########################
    onValueChange = (prop, _value) => {
        const value = this.translateToNumber(_value);
        this.state.editable.updateObj({ [prop]: value });
    };
    translateToNumber = (value) => {
        if (!value)
            return;
        const split = value.split(':');
        return Number(split[0]) * 60 + Number(split[1]);
    };
    translateToString = (value) => {
        let meridiem = 'am';
        if (!exists(value))
            return {
                time: !this.state.editMode ? 'N/A' : undefined,
                meridiem,
            };
        //Translate 24hour format into 12hour format
        if (value >= 12 * 60) {
            value -= 12 * 60;
            meridiem = 'pm';
        }
        const hours = Math.floor(value / 60);
        value -= hours * 60;
        return {
            time: `${String(hours).padStart(2, '0')}:${String(value).padStart(2, '0')}`,
            meridiem,
        };
    };
    onMeridiemChange = async (check, prop) => {
        const editable = this.state.editable;
        const currentTime = editable.item[prop];
        //Time not set yet
        if (!exists(currentTime))
            return;
        //Setting AM
        if (check === 'am') {
            //less than midday
            if (currentTime < 12 * 60)
                return;
            return editable.updateObj({ [prop]: currentTime - (12 * 60) });
        }
        else { //Setting PM
            //More or equal to midday
            if (currentTime >= 12 * 60)
                return;
            return editable.updateObj({ [prop]: currentTime + (12 * 60) });
        }
    };
    // ######################## Render ########################
    render() {
        const className = _className('ehr-order-time', this.state.editMode && 'edit-mode');
        return _jsxs(LL_H_C, { className: className, children: [!this.state.editMode && this.renderView(), this.state.editMode && _jsxs(_Fragment, { children: [this.renderTime('start'), _jsx("div", { className: 'ehr-order-time__separator', children: "-" }), this.renderTime('end')] })] });
    }
    renderView = () => {
        const start = this.translateToString(this.state.editable.item.start);
        const end = this.translateToString(this.state.editable.item.end);
        return _jsxs(_Fragment, { children: [start.time, start.meridiem.toUpperCase(), " - ", end.time, end.meridiem.toUpperCase()] });
    };
    renderTime = (prop) => {
        const timeData = this.translateToString(this.state.editable.get(prop));
        return _jsxs(LL_H_C, { className: 'ehr-order-time__input', children: [_jsx(DefaultEditor_InputTime, { value: timeData.time, editable: this.state.editable, prop: prop, onChange: value => this.onValueChange(prop, value) }), _jsx(TS_Radio, { className: 'label-radio', values: ['am', 'pm'], groupName: 'meridiem', checked: timeData.meridiem ?? 'am', onCheck: check => this.onMeridiemChange(check, prop) })] });
    };
}
//# sourceMappingURL=Renderer_EHROrderTime.js.map